import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';

export const MARTINA_USAGE_CONTROL_QUERY_KEY = ['/api/exai/providers/usage-control'] as const;

export interface MartinaUsageControlGroupState {
  capUsd: number;
  suspended: boolean;
  reason: string | null;
  suspendedAt?: string | null;
}

export interface MartinaActiveLlmRealBalance {
  profileId: string | null;
  availableUsd: number | null;
  status: 'ok' | 'unsupported' | 'error' | null;
  checkedAt: string | null;
}

export interface MartinaUsageControlResponse {
  control: {
    llm: MartinaUsageControlGroupState;
    google: MartinaUsageControlGroupState & {
      automaticBlockDisabled: boolean;
      counterResetAt: string | null;
    };
  };
  llmRealBalance: MartinaActiveLlmRealBalance;
}

/**
 * Stato provider condiviso da banner globale e indicatore nel menu.
 * Il saldo può cambiare fuori dalla sessione CRM (per esempio dopo una
 * ricarica Kimi): non deve restare "fresco" per cinque minuti né richiedere
 * un reload completo per togliere una sospensione già rimossa dal server.
 */
export function useMartinaUsageControl() {
  return useQuery<MartinaUsageControlResponse>({
    queryKey: MARTINA_USAGE_CONTROL_QUERY_KEY,
    queryFn: () => apiRequest('GET', '/api/exai/providers/usage-control'),
    staleTime: 0,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: false,
  });
}
